import { useContext } from 'react';
import { modelStoreContext } from '@app/models';

export const useModelContext = () => useContext(modelStoreContext);
